import { Page } from "@/models/page-models/Page";

export const CustomerSalesComparison: Page = {
  "path": "customer-sales-comparison",
  "name": "Customer Sales Comparison",
  "props": {
    "data": {
      "title": "Customer Sales Comparison",
      "printable": "FALSE",
      "url": "customer-sales-comparison",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesComparisonForm.year",
                  "label": "Select Year",
                  "disabled": "FALSE",
                  "items": "[2024,2025,2026,2027]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesComparisonForm.customer",
                  "label": "Select Customer",
                  "disabled": "fn(NOT,{{fetchedData.salesComparisonForm.year}})",
                  "items": "fetchedData.customer.data",
                  "itemText": "alias",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetComparisonData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.salesComparisonData"
                      },
                      "name": "resetComparisonData"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesComparisonForm.displaySAR",
                  "label": "Data Type",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Quantity\",\"value\":false},{\"text\":\"SAR\",\"value\":true}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetComparisonData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.salesComparisonData"
                      },
                      "name": "resetComparisonData"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load Customer Comparison",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToCustomerSalesComparison",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/customer-sales-comparison",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{fetchedData.salesComparisonForm.customer}}\",\"year\":\"{{fetchedData.salesComparisonForm.year}}\",\"displaySAR\":\"{{fetchedData.salesComparisonForm.displaySAR}}\"}"
                      },
                      "name": "redirectToCustomerSalesComparison"
                    }
                  ],
                  "disabled": "fn(NOT,{{fetchedData.salesComparisonForm.customer}})",
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "salesComparison",
                  "showIf": "{{fetchedData.salesComparisonData.data}}",
                  "comparisonDataVariable": "fetchedData.salesComparisonData.data",
                  "mode": "product",
                  "displaySarVariable": "fetchedData.salesComparisonForm.displaySAR"
                }
              ],
              "showIf": "{{fetchedData.salesComparisonData.data}}",
              "disabled": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.salesComparisonData.data.status}},'),==,'Approved')"
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultSalesComparisonForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultSalesComparisonForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.salesComparisonForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultSalesComparisonForm"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "loadSalesComparisonData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-forecast/customer-sales-comparison",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.salesComparisonData",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.salesComparisonForm"
        },
        "name": "loadSalesComparisonData",
        "executeIf": "fn(LOGICAL,{{fetchedData.salesComparisonForm.customer}},>,0)"
      }
    ],
    "functions": [
      {
        "name": "getDefaultSalesComparisonForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "fn(NUMBER,{{__query.customer}})",
          "year": "fn(CONDITIONAL,{{__query.year}},{{__query.year}},{{CURRENT_YEAR}})",
          "displaySAR": "fn(CONDITIONAL,fn(LOGICAL,{{__query.displaySAR}},==,false),{{__query.displaySAR}},true)"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true,
          "status": ["Closed Customer", "Open Customer"]
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 70
}